import { createAppStore } from '@store/createAppStore';

import { getOrderFlagStateDefinitions } from './service';
import { OrderFlagStateDefinition, OrderFlagStatesState } from './types';

const [orderFlagStatesStore, setOrderFlagStatesStore] =
  createAppStore<OrderFlagStatesState>(
    {
      isLoading: false,
      isError: false,
      loaded: false,
      errorMessage: undefined,
      definitions: [],
    },
    'orderFlagStatesStore',
  );

const initializeOrderFlagStates = async (): Promise<void> => {
  setOrderFlagStatesStore({
    isLoading: true,
    isError: false,
    errorMessage: undefined,
  });

  try {
    const definitions = await getOrderFlagStateDefinitions();

    setOrderFlagStatesStore({
      isLoading: false,
      isError: false,
      errorMessage: undefined,
      loaded: true,
      definitions,
    });
  } catch (error) {
    setOrderFlagStatesStore({
      isLoading: false,
      isError: true,
      loaded: true,
      errorMessage: (error as Error).message,
      definitions: [],
    });
  }
};

const getStateDefinition = (
  flagType: string,
  mode: string,
): OrderFlagStateDefinition | undefined => {
  return orderFlagStatesStore.definitions.find(
    (d) =>
      d.flagType.toLowerCase() === flagType.toLowerCase() &&
      d.mode.toLowerCase() === mode.toLowerCase(),
  );
};

const getAvailableTransitions = (
  flagType: string,
  mode: string,
  currentState: string,
): string[] => {
  const definition = getStateDefinition(flagType, mode);
  if (!definition) return [];

  return definition.transitions
    .filter(
      (t) =>
        t.fromState !== null &&
        t.fromState.toLowerCase() === currentState.toLowerCase(),
    )
    .map((t) => t.toState);
};

const getInitialStates = (flagType: string, mode: string): string[] => {
  const definition = getStateDefinition(flagType, mode);
  if (!definition) return [];

  return definition.transitions
    .filter((t) => t.fromState === null || t.fromState === '')
    .map((t) => t.toState);
};

export {
  orderFlagStatesStore,
  setOrderFlagStatesStore,
  initializeOrderFlagStates,
  getStateDefinition,
  getAvailableTransitions,
  getInitialStates,
};
